import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { Issue } from "../../../models/issue.model";

let IssueDeleteComponent = {
    selector: "vcIssueDelete",
    templateUrl: "/angular/components/issue/modals/issue-delete.component.html",
    bindings: {
        selectedIssue: "=",
    },
    controller: class IssueDeleteController {
        // * bindings for typescript compiler *
        public selectedIssue: Issue;
        // ************************************

        private dialog: DialogUtils;
        public issue: Issue;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.issue = _.cloneDeep(this.selectedIssue);
        }

        confirm(): void {
            this.dialog.hide(this.issue);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("issue")
    .component(IssueDeleteComponent.selector, IssueDeleteComponent);
